import { Icon } from '@chakra-ui/react';

export default function SFQuestionMarkCircle(props) {
  return (
    <Icon
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 20.3281C7.64844 20.3281 4.03125 16.7109 4.03125 12.3594C4.03125 8 7.64062 4.39062 11.9922 4.39062C16.3516 4.39062 19.9688 8 19.9688 12.3594C19.9688 16.7109 16.3594 20.3281 12 20.3281ZM12 19C15.6875 19 18.6406 16.0469 18.6406 12.3594C18.6406 8.67188 15.6797 5.71875 11.9922 5.71875C8.30469 5.71875 5.36719 8.67188 5.36719 12.3594C5.36719 16.0469 8.3125 19 12 19ZM11.8359 13.9766C11.4375 13.9766 11.2109 13.7656 11.2109 13.3594V13.2578C11.2109 12.4922 11.6328 12.0781 12.1953 11.6875C12.875 11.2109 13.2031 10.9531 13.2031 10.4219C13.2031 9.82812 12.7422 9.42188 12.0312 9.42188C11.5078 9.42188 11.1016 9.6875 10.8281 10.1406L10.6875 10.3281C10.5469 10.5156 10.375 10.6406 10.1094 10.6406C9.85156 10.6406 9.57812 10.4531 9.57812 10.1016C9.57812 9.96875 9.60156 9.84375 9.64062 9.71875C9.85156 9 10.7344 8.35938 12.0781 8.35938C13.4062 8.35938 14.5625 9.0625 14.5625 10.3594C14.5625 11.2969 14.0234 11.75 13.2656 12.25C12.7188 12.6094 12.4688 12.8906 12.4688 13.3281V13.4219C12.4688 13.7266 12.2266 13.9766 11.8359 13.9766ZM11.8203 16.3047C11.3672 16.3047 10.9766 15.9375 10.9766 15.4922C10.9766 15.0469 11.3594 14.6797 11.8203 14.6797C12.2812 14.6797 12.6641 15.0391 12.6641 15.4922C12.6641 15.9453 12.2734 16.3047 11.8203 16.3047Z'
        fill='currentColor'
      />
    </Icon>
  );
}
